import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-signup-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './signup-banner.component.html',
  styleUrl: './signup-banner.component.scss',
})
export class SignupBannerComponent {}
